<template>
  <div class="pdf-wrap">
    <pdf v-for="(item, index) in numPages" :src="pdfSrc" :key="item" :page="item" :class="{ bb: index !== numPages - 1 }"></pdf>
  </div>
</template>

<script>
  import pdf from 'vue-pdf';
  export default {
    name: "bsp-pdf-preview",
    components: {
      pdf
    },
    props:{
      pdfSrc: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        numPages: 0,
        pdfUrl: ''
      }
    },
    watch: {
      pdfSrc(val) {
        if (val) {
          this.getTotalPdfUrl();
        }
      }
    },
    methods: {
      getTotalPdfUrl() {
        this.pdfUrl = pdf.createLoadingTask(this.pdfSrc);
        this.pdfUrl.promise.then((pdf) => {
          this.numPages = pdf.numPages;
        })
      }
    }
  }
</script>

<style scoped>

</style>
